import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as actions from '../actions';
import BlogItem from './common/BlogItem';
import Loader from './common/Loader';
import MainContent from './common/MainContent';

class Blog extends Component {
	state = {};

	componentDidMount() {
		const { blog, getBlog, match } = this.props;
		if (process.env.NODE_ENV === 'production' || !blog || !blog.id) {
			getBlog(match.params.id);
		}
	}

	render() {
		const { blog, isLoading } = this.props;
		return (
			<MainContent>
				<div className="row d-flex justify-content-center">
					<Loader loading={isLoading} message={'Loading blog'}>
						{!blog || !blog.id ? (
							'Blog not found!'
						) : (
							<React.Fragment>
								<Helmet>
									<title>{blog.title}</title>
									<meta name="description" content={blog.description} />
									<meta name="og:image" content={blog.image} />
								</Helmet>
								<BlogItem
									content={blog.content}
									datePosted={blog.datePosted}
									description={blog.description}
									id={blog.id}
									image={blog.image}
									meta={blog.meta}
									title={blog.title}
								/>
							</React.Fragment>
						)}
					</Loader>
				</div>
			</MainContent>
		);
	}
}

function mapStateToProps(state) {
	const blog = state.blog;
	return {
		blog: blog.data,
		isLoading: blog.isLoading || false,
	};
}

export default withRouter(
	connect(
		mapStateToProps,
		actions,
	)(Blog),
);



// WEBPACK FOOTER //
// ./src/components/Blog.js